import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { OverrideRule } from '../models/overrideRule';  

@Injectable({ providedIn: 'root' })

export class OverrideRuleService { 
  private _ENDPOINT: string = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/overrideRules';   
  }
 
  getAll(brandId: number): Observable<Array<OverrideRule>> { 
    return this.http.get<Array<OverrideRule>>(this._ENDPOINT + '?brandId='+brandId);
  }
   
  getById(id: any): Observable<OverrideRule> {
    const url = this._ENDPOINT+'/'+id;
    return this.http.get<OverrideRule>(url);
  }

  /** POST: add a new overrideRule to the server */
  add(overrideRule: OverrideRule): Observable<OverrideRule> {
    return this.http.post<OverrideRule>(this._ENDPOINT, overrideRule, this.httpOptions).pipe(
      tap((newOverrideRule: OverrideRule) => this.log('added overrideRule w/ id=${newOverrideRule.id}')),
      catchError(this.handleError<OverrideRule>('add'))
    );
  }

  /** DELETE: delete the overrideRule from the server */
  delete(id: number): Observable<OverrideRule> {
    const url = this._ENDPOINT + '/' + id;

    return this.http.delete<OverrideRule>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted overrideRule id=${id}')),
      catchError(this.handleError<OverrideRule>('delete'))
    );
  }

  /** PUT: update the overrideRule on the server */
  update(id: number, overrideRule: OverrideRule): Observable<any> {
    console.log(overrideRule);
    return this.http.put(this._ENDPOINT + "/" + id, overrideRule, this.httpOptions).pipe(
      tap(_ => this.log('updated overrideRule id=${overrideRule.Id}')),
      catchError(this.handleError<any>('update'))
    );
  }
   
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a OverrideRuleService message with the MessageService */
  private log(message: string) {
    this.messageService.add('OverrideRuleService: ${message}');
  }
}
